import { Component, OnInit } from '@angular/core';
import { ImportsModule } from '../imports';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart, scales } from 'chart.js';

@Component({
  selector: 'app-charts',
  standalone: true,
  imports: [
    ImportsModule
  ],
  templateUrl: './charts.component.html',
  styleUrl: './charts.component.css'
})
export class ChartsComponent implements OnInit {
  tabMenuItems: MenuItem[] = [];
  activeItem!: MenuItem;

  constructor(private router: Router) { }

  ngOnInit() {
    const currentRoute = this.router.config.find(route => route.path === 'Charts');
    if (currentRoute && currentRoute.children) {
      this.tabMenuItems = currentRoute.children.map(childRoute => {
        const routerLink = childRoute.path !== "" ? [childRoute.path] : ['/Charts'];
        return {
          label: childRoute.data ? childRoute.data['label'] : '',
          routerLink: routerLink,
          selected: false
        };
      });
      if (this.router.url === '/Charts') {        
        this.router.navigate([currentRoute.path, this.tabMenuItems[0].routerLink.toString()]);
        this.activeItem = this.tabMenuItems[0];
      }
    }
    const datalabels = ChartDataLabels;
    datalabels['id'] = 'datalabels';

    const legendMargin = {
      id: 'legendMargin',
      
      afterInit: function(chart: any, args: any, plugins: any) {
        const originalFit = chart.legend.fit;
        chart.legend.fit = function() {
          if(originalFit){
            originalFit.call(this);
          }
          return this.height += 20;
        }
      }
    }

    Chart.register(datalabels, legendMargin);
  }

  changeTab(event: any) {
    this.activeItem = event.item;
  }
}
